import './App.css';
import { Table, Text } from '@mantine/core'; 

type Prediction = {
  value: number;
  prob: number;
}

export default function PredictionResults({probs} : {probs: Float64Array}) {
  function convertProbsArrayToPredictionArray(probabilities: Float64Array): Prediction[] {
    let outputArray: Prediction[] = [];

    probabilities.forEach((prob, index) => outputArray.push({value: index, prob: prob}));

    return outputArray;
  }

  function getTop3Probs(probabilities: Float64Array):  Prediction[] {
    let predictionList = convertProbsArrayToPredictionArray(probabilities);

    predictionList.sort((a,b) => b.prob - a.prob);

    return predictionList.slice(0,3);
  }

  function getTopPrediction(probabilities: Float64Array): Prediction {
    const predictions = convertProbsArrayToPredictionArray(probabilities);
    let topPrediction: Prediction = predictions[0];

    predictions.forEach(prediction => {
      if(prediction.prob > topPrediction.prob) {
        topPrediction = prediction;
      }
    }) 

    return topPrediction;
  }

  const predictionTop3List = getTop3Probs(probs).map((prediction, i) =>
    <Table.Tr key={prediction.value} className={i === 0 ? 'top-row' : undefined}>
      <Table.Td>{prediction.value}</Table.Td>
      <Table.Td>{(prediction.prob*100).toFixed(2)}%</Table.Td>
    </Table.Tr>);

  return <div className="results">
    <div className="prediction-hero">
      <Text className="prediction-label">Model prediction</Text>
      <Text className="prediction-value">{getTopPrediction(probs).value}</Text>
    </div>
    <Table>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Number</Table.Th>
          <Table.Th>Probability</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>{predictionTop3List}</Table.Tbody>
    </Table>
  </div>
}
